




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ImportPage from "@/lib/import-page";
import { mixins } from "vue-class-component";

@Component({
  components: {},
})
export default class ImportPurchaseOrder extends mixins(AbpBase, ImportPage) {
  importPageName = "PurchaseOrder";
  namespace = "purchaseOrderImport";
  //filters
  current: number = 0;
  purchaseOrderFileId: number = 0;
  spinShow: boolean = false;
  get countItems() {
    return this.$store.state.purchaseOrderImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.purchaseOrderImport.countImportedItems;
  }
  get list() {
    return this.$store.state.purchaseOrderImport.itemsImported;
  }
  get loading() {
    return this.$store.state.purchaseOrderImport.loading;
  }
  create() {}
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "purchaseOrderImport/export",
      data: this.purchaseOrderFileId,
    });
  }

  columns = [
    {
      title: this.L("ErrorMsg"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("PoCode"),
      width: 150,
      key: "poCode",
    },
    {
      title: this.L("ContactName"),
      width: 150,
      key: "contactName",
    },
    {
      title: this.L("ContactPhone"),
      width: 150,
      key: "contactPhone",
    },
    {
      title: this.L("ScrClientBranchCode"),
      width: 150,
      key: "scrClientBranchCode",
    },
    {
      title: this.L("AssetTypeCode"),
      width: 150,
      key: "assetTypeCode",
    },
    {
      title: this.L("ConditionTypeCode"),
      width: 150,
      key: "conditionTypeCode",
    },
    {
      title: this.L("WarehouseCode"),
      width: 150,
      key: "warehouseCode",
    },
    {
      title: this.L("ShippingDate"),
      width: 150,
      key: "shippingDate",
    },
    {
      title: this.L("Type"),
      width: 100,
      key: "type",
    },
    {
      title: this.L("Supplier"),
      width: 100,
      key: "supplierCode",
    },
    {
      title: this.L("SKU"),
      width: 150,
      key: "line_SKU",
    },
    {
      title: this.L("Qty"),
      width: 100,
      key: "line_Qty",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_Qty));
      },
    },
    {
      title: this.L("ManufactureMonth"),
      width: 100,
      key: "manufactureMonth",
    },
    {
      title: this.L("Price"),
      width: 100,
      key: "line_Price",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.line_Price));
      },
    },
    {
      title: this.L("IsPrep"),
      width: 80,
      key: "line_IsPrep",
    },
    {
      title: this.L("Tax"),
      width: 80,
      key: "line_Tax",
    },
    {
      title: this.L("Note"),
      width: 120,
      key: "note",
    },
    {
      title: this.L("IsImported"),
      key: "isImported",
      align: "center",
      fixed: "right",
      width: 80,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  async created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Po", (notification) => {
        this.processNotifierImportPurchaseOrder(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Po", (notification) => {
          this.processNotifierImportPurchaseOrder(notification);
        });
      });
    }
  }
  processNotifierImportPurchaseOrder(notification: any) {
    if (notification.poFileId == this.purchaseOrderFileId) {
      this.$store.commit({
        type: "purchaseOrderImport/processNotifier",
        data: notification,
      });
    }
  }
  handleBeforeUpload(file) {
    const fileExt = file.name
      .split(".")
      .pop()
      .toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("purchaseOrderImport/uploadImportPurchaseOrderFile", data)
          .then((res) => {
            this.resetList();
            this.resetCountItems();
            this.resetCountImportedItems();
            this.activeStep(true);
            this.purchaseOrderFileId = res;
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
